export default [
  {
    name: 'includes_quote.item_1.title',
    description: 'includes_quote.item_1.desc',
  },
  {
    name: 'includes_quote.item_2.title',
    description: 'includes_quote.item_2.desc',
  },
  {
    name: 'includes_quote.item_3.title',
    description: 'includes_quote.item_3.desc',
  },
  {
    name: 'includes_quote.item_4.title',
    description: 'includes_quote.item_4.desc',
  },
  {
    name: 'includes_quote.item_5.title',
    description: 'includes_quote.item_5.desc',
  },
  {
    name: 'includes_quote.item_6.title',
    description: 'includes_quote.item_6.desc',
  },
  
  
]
